<template>
    <mailings :mailings="list"></mailings>
</template>

<script>
export default {
    mounted() {},
    created() {},
    props: ["mailings"],
    data() {
        return {};
    },
    computed: {
        list() {
            var self = this;
            try {
                if (this.mailings) {
                    return this.mailings.filter(function (u) {
                        return u.status != "concept";
                    });
                }
            } catch (error) {} //
            return this.mailings;
        },
    },
};
</script>
